import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=c3b49ffa&scoped=true&"
import script from "./NavMenu.vue?vue&type=script&lang=js&"
export * from "./NavMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=c3b49ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b49ffa",
  null
  
)

export default component.exports